export enum TypeOfCreditReleaseEnum {
  CR = 'Crédito',
  DB = 'Débito',
  EST = 'Estorno'
}

export enum TypeOfClassPracticalEnum {
  MONITORADA = 'Monitorada',
  NAO_MONITORADA = 'Não monitorada'
}

export enum CreditEnrollmentEnum {
  PENDENTE = 'Pendente de Consumo',
  SUCESSO = 'Consumido com Sucesso',
  ESTORNADO = 'Estornado',
  SALDO_SEM_ALTERACAO = 'Saldo sem Alteração',
  ERRO = 'Com erro'
}
